// extracted by mini-css-extract-plugin
export var section = "_2b-1";
export var topNav = "_2b-0";